export default __webpack_public_path__ + "static/media/MISTRZ.329fd630.png";